var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"feature-list",attrs:{"data-ci":"feature-list"}},_vm._l((_vm.features),function(feature){return _c('li',{class:feature.class,attrs:{"data-ci":feature.dataCi || feature.class}},[(feature.rawHtml)?_c('span',{domProps:{"innerHTML":_vm._s(feature.description)}}):_c('span',[_vm._v(_vm._s(feature.description))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }